import React, { useCallback, useState } from 'react'
import NumberFormat from 'react-number-format'
import moment from 'moment'
import BeneficiaryTransferService from '../../services/beneficiary-transfers.service'
import { AUTH_KEYS, RECIPTS_KEYS, REQUESTS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function TransferReceipts({ dataSource = [] }) {
  const [expanded, setExpanded] = useState(null)
  const { t } = useTranslation()

  const getDownload = useCallback(async (selected) => {
    try {
      //   setLoading(true)
      const reqParams = {
        transRefNum: selected.transactionRef,
        refId: selected.receiptId,
        module: 'FUNDTRANSFER',
      }
      await BeneficiaryTransferService.downLoadReport(reqParams)
      //   setLoading(false)
    } catch (err) {
      //   setLoading(false)
    }
  }, [])

  const getTransferType = useCallback((transferType) => {
    switch (transferType) {
      case 'OAT':
        return t(RECIPTS_KEYS.OAT)
      case 'RTGS':
        return t(RECIPTS_KEYS.RTGS)
      case 'IAT':
        return t(RECIPTS_KEYS.IAT)
      case 'SWIFT':
        return t(RECIPTS_KEYS.SWIFT)
      case 'DDACC':
        return t(RECIPTS_KEYS.DDACC)
    }
  }, [])

  return (
    <>
      <div style={{ justifyContent: ' space-between', alignItems: 'center' }}>
        {dataSource.map((item, index) => (
          <div
            key={index}
            className='loan-card '
            onClick={() => (expanded === index ? setExpanded(null) : setExpanded(index))}>
            <div className='loan-header'>
              <div>
                <span>
                  {t(RECIPTS_KEYS.REF_ID)} : {item.transactionRef}
                </span>
                <div style={{ display: 'flex' }}>
                  <span>{t(RECIPTS_KEYS.TRANSACTION_DATE)}: </span>
                  <span style={{ marginLeft: 5 }}>
                    {moment(item.transTime).format('DD-MM-YYYY')} &nbsp;{''}
                    {moment(item.transTime).format('HH:MM:SS')}
                  </span>
                </div>
              </div>
              <div>
                <div className='d-flex' style={{ justifyContent: 'end' }}>
                  <label style={{ fontSize: '6px' }}>{item?.reqObj?.fin?.srcAccCcy}</label>
                  &nbsp;
                  <NumberFormat
                    value={item?.reqObj?.fin?.amount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    className='float-right'
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </div>
                <div>
                  <span>{getTransferType(item?.reqObj?.nfin?.transferType)}</span>
                </div>
              </div>
            </div>
            {expanded === index && (
              <div className='loan-details'>
                <div className='row beneficiary-details justify-space-between '>
                  <div className='col-12'>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.FROM_ACCOUNT)}</div>
                        <div className='value'>{item?.reqObj?.fin?.srcAccount}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.TO_ACCOUNT)}</div>
                        <div className='value'>{item?.reqObj?.fin?.destAccount}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.TRANSACTION_DATE)}</div>
                        <div className='value'>
                          {moment(item.transTime || '-').format('DD-MM-YYYY')} &nbsp;{' '}
                          {moment(item.transTime || '-').format('HH:MM:SS')}
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.TRANS_CURRENCY)}</div>
                        <div className='value'>{item?.reqObj?.fin?.txnCurrency}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.BENE_NAME)}</div>
                        <div className='value'>{item?.reqObj?.nfin?.beneficiaryName}</div>
                      </div>
                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.AMOUNT)}</div>
                        <div className=' d-flex value'>
                          <NumberFormat
                            value={item?.reqObj?.fin?.amount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={''}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            allowEmptyFormatting
                          />
                        </div>
                      </div>

                      <div className='col-5'>
                        <div className='label'>{t(RECIPTS_KEYS.TRANFER_TYPE)}</div>
                        <div className='value'>
                          {getTransferType(item?.reqObj?.nfin?.transferType)}
                        </div>
                      </div>
                      <div className='col-7'>
                        <div className='label'>{t(RECIPTS_KEYS.REMARKS)}</div>
                        <div className='value'>{item?.reqObj?.fin?.remarks}</div>
                      </div>
                    </div>

                    <div class='row'>
                      <h6
                        className='download-link'
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          getDownload(item)
                        }}>
                        {t(RECIPTS_KEYS.DOWNLOAD)}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  )
}
